<template>
  <div class="col-md-6 mb-3">
    <slot />
  </div>
</template>
